import React from 'react'
// import styles from './RegionalEmbed.scss'
import {connect} from 'react-redux'
import p from 'prop-types'
import preloadImg from 'lib/preloadImg'
import {photoMedium} from 'lib/urlHelpers'
import {loadRSO, loadGeoJSON} from 'lib/api/embeds/regional'
import {RegionalEmbedlet} from './RegionalEmbedlet'
import {getConsole} from 'lib/getConsole'
const console = getConsole('embeds', 'RegionalEmbed')

// To calculate bounding boxes: https://runkit.com/qrohlf/59de4a095f7b5000127707d3
export class RegionalEmbed extends React.PureComponent {
  static propTypes = {
    id: p.oneOfType([p.number, p.string]).isRequired,
    metricUnits: p.string,
    showUnitConversion: p.string,
    boundingBox: p.string,
    overlay: p.string,
    poiBar: p.string,
    hot: p.string,
    useClusters: p.string,
    onlyShowClusters: p.string,
    scrollWheelZoom: p.string,
    hideFeatureLink: p.string,
    showDetailsOnHover: p.string,
    showStartMarkers: p.string,
    clusterTheme: p.string,
    selectedColor: p.string
  }

  static defaultProps = {
    boundingBox: '-122.463036,41.9727,-120.179602,45.7153',
    overlay: 'rwgps'
  }

  componentDidMount = () => {
    window.getBounds = this.getBounds

    const {loadRSO, loadGeoJSON} = this.props
    loadRSO(this.props.id).then(() => {
      loadGeoJSON(this.props.id, this.props.rso.get('rso').updated_at)
      this.preloadImages()
    })
  }

  preloadImages = () => {
    const rso = this.props.rso.get('rso')
    const assets = this.props.rso.get('assets')

    rso.route_ids.forEach(id => {
      const route = assets.route && assets.route[id]
      if (!route) {
        console.warn('could not find route metadata for route ' + id)
        return
      }
      const pid = route.highlighted_photo_id
      if (!pid) { return }
      preloadImg(photoMedium(pid))
      console.log('preloading image ' + pid)
    })
  }

  getParsedBounds = (boundingBoxString) => {
    const boundsArr = boundingBoxString.split(',').map(parseFloat)
    return [
      [boundsArr[1], boundsArr[0]],
      [boundsArr[3], boundsArr[2]]
    ]
  }

  render () {
    const {rso, geoJSON, boundingBox, ...props} = this.props

    const details = {
      colors: rso.get('colors'),
      urls: rso.get('urls'),
      poiTags: rso.get('poiTags')
    }

    const enabledPoiTags = rso.get('enabledPoiTags')
    const assets = rso.get('assets')

    // We're waiting for an rso.id to render, so have a chance to use embed_settings.bounding_box. Otherwise we'll initially load the map set to the default props (which is portland) and then use the bounds specified, which means downloading too many map tiles.  The same thing also happens with overlay.  defaultProps are included to support legacy urls
    return (
      rso.get('id') && <RegionalEmbedlet initialBounds={this.getParsedBounds(boundingBox)} geoJSON={geoJSON} rso={rso.get('rso')} details={details} enabledPoiTags={enabledPoiTags} assets={assets} pois={rso.get('pois')} {...props} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {regionalEmbed} = state
  const embedSettings = regionalEmbed.getIn(['embedData', 'embedSettings'])

  return {
    rso: regionalEmbed.get('embedData'),
    geoJSON: regionalEmbed.get('geoJSON'),

    // Default to ownProps (which means url params), fall back to embedSettings
    boundingBox: ownProps.boundingBox || embedSettings.get('boundingBox'),
    poiBar: ownProps.poiBar || embedSettings.get('poiBar'),
    metricUnits: ownProps.metricUnits || embedSettings.get('metricUnits'),
    overlay: ownProps.overlay || embedSettings.get('overlay')
  }
}

const mapDispatchToProps = {
  loadRSO: loadRSO,
  loadGeoJSON: loadGeoJSON
}

export const RegionalEmbedContainer = connect(mapStateToProps, mapDispatchToProps)(RegionalEmbed)
